import * as React from "react";
const VisaDenialLogo = (props) => (
  <svg
  width={props.width || 18}
  height={props.height || 22}
  viewBox="0 0 18 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
  >
    <path
      d="M7.52917 14.6792L13.65 8.55833L12.1062 7.01458L7.52917 11.5917L5.25417 9.31667L3.71042 10.8604L7.52917 14.6792ZM8.66667 21.6667C6.15694 21.0347 4.08507 19.5948 2.45104 17.3469C0.817014 15.099 0 12.6028 0 9.85834V3.25L8.66667 0L17.3333 3.25V9.85834C17.3333 12.6028 16.5163 15.099 14.8823 17.3469C13.2483 19.5948 11.1764 21.0347 8.66667 21.6667Z"
      fill="url(#paint0_linear_4498_14672)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4498_14672"
        x1={-4.98291}
        y1={0.43418}
        x2={17.7671}
        y2={25.1342}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.352732} stopColor="#9E63E7" />
        <stop offset={1} stopColor="#704C9C" />
      </linearGradient>
    </defs>
  </svg>
);
export default VisaDenialLogo;
